import { render, staticRenderFns } from "./ChatEditor.vue?vue&type=template&id=6b39774d&scoped=true&"
import script from "./ChatEditor.vue?vue&type=script&setup=true&lang=ts&"
export * from "./ChatEditor.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./ChatEditor.vue?vue&type=style&index=0&id=6b39774d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b39774d",
  null
  
)

export default component.exports